import { render, staticRenderFns } from "./FotoCheck.vue?vue&type=template&id=504c3c71"
import script from "./FotoCheck.vue?vue&type=script&lang=js"
export * from "./FotoCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports